module.exports = __webpack_public_path__ + "static/img/9.47ec871.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/9.png
// module id = pMXE
// module chunks = 0